import axios from "axios";
import React, { Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import Pagination from "../components/Pagination";
import PortfoliosView from "../components/PortfoliosView";
import Sectiontitle from "../components/Sectiontitle";
import Spinner from "../components/Spinner";

function Photography() {
  const [portfolios, setPortfoios] = useState([]);
  const [information, setInformation] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [portfoliosPerPage] = useState(15);

  useEffect(() => {
    axios.get("/api/information").then((response) => {
      setInformation(response.data);
    });
    let mounted = true;
    axios.get("/api/portfolios").then((response) => {
      if (mounted) {
        setPortfoios(response.data);
      }
    });
    return () => (mounted = false);
  }, []);

  const indexOfLastPortfolios = currentPage * portfoliosPerPage;
  const indexOfFirstPortfolios = indexOfLastPortfolios - portfoliosPerPage;
  const currentPortfolios = portfolios.slice(
    indexOfFirstPortfolios,
    indexOfLastPortfolios
  );

  const paginate = (e, pageNumber) => {
    e.preventDefault();
    setCurrentPage(pageNumber);

    // Smooth scroll to the top of the photography section
    const section = document.querySelector(".mi-about");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <Layout>
      <Helmet>
        <title>Paul Ritter | Photography | North Bay Photographer</title>
        <meta
          name="description"
          content="I am a photographer in North Bay who specializes in capturing emotive and environmental portraits, landscapes and wildlife."
        />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-about mi-section mi-padding-top mi-padding-bottom">
          <div className="container">
            <Sectiontitle title="Photography" />
            <p>{information.aboutPhotography}</p>
            <PortfoliosView portfolios={currentPortfolios} />
            {!(portfolios.length > portfoliosPerPage) ? null : (
              <Pagination
                className="mt-50"
                itemsPerPage={portfoliosPerPage}
                totalItems={portfolios.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            )}
          </div>
        </div>
      </Suspense>
    </Layout>
  );
}

export default Photography;
